import { render } from "./OrganizationCreateComponent.vue?vue&type=template&id=73b5a8e3"
import script from "./OrganizationCreateComponent.vue?vue&type=script&lang=js"
export * from "./OrganizationCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__